module.exports = __webpack_public_path__ + "static/media/img-benefit-applewatch-1-mobile@2x.2eb4f44e.png";